import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { actionSheetClass, actionSheetSlideDownClass, StyledActionSheetModal } from './MobileActionSheet.styled';
import { MobileActionSheetItem } from './MobileActionSheetItem';
import { mobileActionSheetItemHeight } from './MobileActionSheetItem.styled';
export function MobileActionSheet(props) {
  // calculate height of menu based on number of items and overall padding
  var menuHeight = props.menuItems.length * (mobileActionSheetItemHeight + 8) + 24;
  var overFlowMenustyle = {
    height: menuHeight + 'px'
  };
  var actionSheetElement = React.useRef(null);
  var onDismiss = function onDismiss() {
    var _props$onDismiss;
    if (actionSheetElement.current) {
      actionSheetElement.current.className = "".concat(actionSheetClass, " ").concat(actionSheetSlideDownClass);
    }
    (_props$onDismiss = props.onDismiss) === null || _props$onDismiss === void 0 ? void 0 : _props$onDismiss.call(props);
  };
  return /*#__PURE__*/React.createElement(StyledActionSheetModal, _extends({}, props, {
    onDismiss: onDismiss
  }), /*#__PURE__*/React.createElement("div", {
    style: overFlowMenustyle,
    className: actionSheetClass,
    ref: actionSheetElement
  }, props.menuItems.map(function (item, index) {
    return !!item && /*#__PURE__*/React.createElement(MobileActionSheetItem, _extends({
      key: "".concat(index)
    }, item, {
      closeMenu: onDismiss
    }));
  })));
}